import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerMember,
  BackendMutationUpdateCustomerMemberRoleArgs,
} from 'src/types/backend';

import { CUSTOMER_MEMBER_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation UpdateCustomerMemberRole($customerId: ID!, $email: String!, $role: UserRoleEnum!) {
    updateCustomerMemberRole(customerId: $customerId, email: $email, role: $role) {
      ...CustomerMember
    }
  }
  ${CUSTOMER_MEMBER_FRAGMENT}
`;

type Variables = BackendMutationUpdateCustomerMemberRoleArgs;
type Result = BackendCustomerMember;

export const updateCustomerMemberRole = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
